<template lang="html">
  <div class="content content--full-screen">
    <div class="background"
         :style="{
           'backgroundImage': `url('${require('@/assets/views/login/bg.webp')}')`
         }" />
    <div class="login-wrapper">
      <div class="login-frame">
        <img src="@/assets/views/login/aibee-logo.webp" class="login-frame__logo">
        <div class="input-area-wrapper">
          <img src="@/assets/views/login/aside.webp" class="input-area-wrapper__aside">
          <div class="input-area">
            <div class="input-area__title">
              账户登录
            </div>
            <AiInput v-model="userName" placeholder="邮箱/账户名" />
            <AiInput v-model="password"
                     placeholder="密码"
                     type="password"
                     :pattern="hintText.length > 0 ? 'warning' : 'default'"
                     @keyup.enter.native="login" />
            <div class="input-area__hint">
              <i v-if="hintText && hintText.length" class="material-icons">error_outline</i>
              {{ hintText }}
            </div>
            <div class="ai-button ai-button--primary" @click="login">
              登录
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hintText: '',
      userName: '',
      password: ''
    };
  },
  methods: {
    async login() {
      try {
        const params = {
          user_name_or_email: this.userName,
          password: this.password
        };
        const { data } = await this.$http.post('/admin/login', params);
        if (data.error_no === 200) {
          let home = '/x/models';
          const user = { user_id: data.data.user_id, username: data.data.username };
          window.localStorage.setItem('user', JSON.stringify(user));

          if (this.$route.query.redirect) home = this.$route.query.redirect;
          // this.$log(home.indexOf('%2'));
          this.$router.replace(home);
        } else {
          this.hintText = '密码错误';
        }
      } catch (e) {
        // something went wrong
        this.hintText = '密码错误';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.background {
  position: absolute;
  width: 100vw;
  height: 100vh;
  background-size: cover;
  background-position: 0% 10%;
}

.login-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  height: 100vh;
  width: 100vw;
}

.login-frame {
  min-width: 1090px;
  min-height: 636px;
  background-color: white;
  position: relative;
  box-shadow: 0 0 30px 10px rgba(0, 0, 0, .3);
  border-radius: 30px;
  padding: 32px 55px;

  &__logo {
    width: 172px;
    height: 53px;
    margin: 15px 15px 60px 15px;
    display: block;
  }
}

.input-area-wrapper {
  display: flex;

  &__aside {
    width: 600px;
    height: 400px;
  }
}

.input-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 20px 0 80px;

  &__title {
    font-size: 30px;
    color: #666;
    text-align: center;
    margin-bottom: 24px;
  }

  &__hint {
    align-self: flex-start;
    font-size: 14px;
    color: #f50;
    display: flex;
    align-items: center;
    min-height: 20px;

    .material-icons {
      margin-right: 4px;
      font-size: 16px;
    }
  }

  .ai-input-wrapper {
    width: 390px;
    height: 60px;
    margin: 24px 0 8px;
    font-size: 18px;

    .ai-input {
      padding: 2px 16px;

      &:focus {
        padding: 1px 15px;
      }

      &::placeholder {
        font-weight: 300;
      }
    }
  }

  .ai-button {
    width: 384px;
    height: 54px;
    font-size: 24px;
    font-weight: 500;
    margin: 12px 0;
  }
}
</style>
